const TOKEN_KEY = 'ssAdminToken';

export const readToken = (): string | null => {
  try {
    return window.sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const writeToken = (token: string): void => {
  try {
    window.sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    return;
  }
};

export const dropToken = (): void => {
  try {
    window.sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    return;
  }
};
